import type { IConfigCatClient } from 'configcat-common';
import * as configcat from 'configcat-js';
import { useEffect, useRef, useState } from 'react';
import { singletonHook } from 'react-singleton-hook';

import config from '../config/appConfig';

const init: { [name: string]: string } = {};
export interface KeyValues {
  settingKey: string;
  settingValue: string;
}

const useFeatureFlagsImplementation = () => {
  const [featureFlags, setFeatureFlags] = useState(init);
  const configCatClient = useRef<IConfigCatClient | null>(null);

  const updateFeatureFlags = async () => {
    if (!configCatClient.current) {
      return;
    }
    configCatClient.current.getAllValues((keyValues: KeyValues[]) => {
      const values: { [name: string]: string } = {};
      keyValues.forEach((keyValue: KeyValues) => {
        values[keyValue.settingKey] = keyValue.settingValue;
      });
      setFeatureFlags(values);
    });
  };

  useEffect(() => {
    const currentConfigCat = configcat.createClientWithAutoPoll(config.config.configCatKey, {
      configChanged: updateFeatureFlags,
    });
    configCatClient.current = currentConfigCat;
    updateFeatureFlags();

    return () => {
      currentConfigCat.dispose();
    };
  }, []);

  return featureFlags;
};

export const useFeatureFlags = singletonHook(init, useFeatureFlagsImplementation);
